import { ContractReviewState, ContractReviewUnloadState } from '../../states/ContractReview.States';
import * as actions from '../../actions/ContractReview.Actions';
import { replaceInLists } from './ContractReview.Shared';

/** Detalle de una revisión (con hallazgos y veredictos). */
export default function ContractReviewDetailReducer(state: ContractReviewState | undefined, action: any): ContractReviewState {
  const current = state ?? ContractReviewUnloadState;
  switch (action.type) {
    case actions.CONTRACT_REVIEW_GETBYID_REQUEST:
      return { ...current, loadingReviewId: action.reviewId, failOnGettingReview: false, reviewError: undefined };
    case actions.CONTRACT_REVIEW_GETBYID_SUCCESS:
      return {
        ...current,
        loadingReviewId: undefined,
        failOnGettingReview: false,
        reviewError: undefined,
        byId: { ...current.byId, [action.reviewId]: action.review },
        listByContract: replaceInLists(current.listByContract, action.review)
      };
    case actions.CONTRACT_REVIEW_GETBYID_FAILURE:
      return { ...current, loadingReviewId: undefined, failOnGettingReview: true, reviewError: action.error };
    default:
      return current;
  }
}
